// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.website-title {
font-size: 2rem; 
font-style: normal;
font-weight: 300;
letter-spacing: 1px; 
line-height: 1.4;
color:#545454;
padding-top: 20px;


}



.title-style {
    border-bottom:"2px solid #F2F2F2" !important;

}
@media screen and (min-width: 1200px) {
    .title-style {
     margin:auto;
    }
    }


@media screen and (min-width: 900px) and (max-width: 1200px) {
    .title-style {
     margin:auto;
    }
    }

@media screen and (min-width: 600px) and (max-width: 900px) {
.title-style {
  margin: auto;
}
}

@media screen and (min-width: 400px) and (max-width: 600px)   {
    .title-style {
        margin-left: 0.3rem !important;
       margin-right: 0.3rem !important; 
    }
    }




.basic-nav-dropdown  {
color:  #116AAB !important;
font-family: Open Sans !important;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px;
}

.top-bar-icon {
     margin-right: 1em;
    margin-left: 1em; 
    vertical-align: text-top;
}

.home-icon {
   
    vertical-align: text-top;
}

.dropdown-toggle::after {
    display: none !important;
  } 


`, "",{"version":3,"sources":["webpack://./src/styles/NavBar.css"],"names":[],"mappings":";;AAEA;AACA,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,gBAAgB;AAChB,aAAa;AACb,iBAAiB;;;AAGjB;;;;AAIA;IACI,4CAA4C;;AAEhD;AACA;IACI;KACC,WAAW;IACZ;IACA;;;AAGJ;IACI;KACC,WAAW;IACZ;IACA;;AAEJ;AACA;EACE,YAAY;AACd;AACA;;AAEA;IACI;QACI,8BAA8B;OAC/B,+BAA+B;IAClC;IACA;;;;;AAKJ;AACA,0BAA0B;AAC1B,iCAAiC;AACjC,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;KACK,iBAAiB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;EAC1B","sourcesContent":["\n\n.website-title {\nfont-size: 2rem; \nfont-style: normal;\nfont-weight: 300;\nletter-spacing: 1px; \nline-height: 1.4;\ncolor:#545454;\npadding-top: 20px;\n\n\n}\n\n\n\n.title-style {\n    border-bottom:\"2px solid #F2F2F2\" !important;\n\n}\n@media screen and (min-width: 1200px) {\n    .title-style {\n     margin:auto;\n    }\n    }\n\n\n@media screen and (min-width: 900px) and (max-width: 1200px) {\n    .title-style {\n     margin:auto;\n    }\n    }\n\n@media screen and (min-width: 600px) and (max-width: 900px) {\n.title-style {\n  margin: auto;\n}\n}\n\n@media screen and (min-width: 400px) and (max-width: 600px)   {\n    .title-style {\n        margin-left: 0.3rem !important;\n       margin-right: 0.3rem !important; \n    }\n    }\n\n\n\n\n.basic-nav-dropdown  {\ncolor:  #116AAB !important;\nfont-family: Open Sans !important;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 24px;\n}\n\n.top-bar-icon {\n     margin-right: 1em;\n    margin-left: 1em; \n    vertical-align: text-top;\n}\n\n.home-icon {\n   \n    vertical-align: text-top;\n}\n\n.dropdown-toggle::after {\n    display: none !important;\n  } \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
